import { colors } from '../../theme/colors';
import { CircularProgress } from '@mui/material';

const CircleLoadingIndicator = ({ size = 20, color = colors.textPrimary }) => {
  return (
    <CircularProgress
      size={size}
      style={{
        color: color,
      }}
    />
  );
};

export default CircleLoadingIndicator;
